import { forwardRef } from "react";
import "./CardBack.less";
import { WavePatternSVG } from "./WavePatternSVG";
import { QuestionnaireTextSVG } from "./QuestionnaireTextSVG";

interface CardBackProps {
  width: number;
  height: number;
  status?:
    | "photo-pending"
    | "photo-review"
    | "photo-rejected"
    | "questionnaire"
    | "sent"
    | "default";
  visible?: boolean;
}

/**
 * Back side of the card preview that displays different patterns based on current application state
 * - Shows a questionnaire-themed background for questionnaire state and a wave pattern for sent state
 * - Scales the SVG elements proportionally based on card dimensions
 */
export const CardBack = forwardRef<HTMLDivElement, CardBackProps>(
  ({ width, height, status = "default", visible = false }, ref) => {
    // Calculate SVG scale factor based on card height
    // 224px is the base height for mobile, scale proportionally for larger sizes
    const baseHeight = 224;
    const scaleFactor = Math.min(Math.max(height / baseHeight, 0.9), 1.4);

    return (
      <div
        ref={ref}
        className={
          visible ? "card-back__wrapper card-back__wrapper--visible" : "card-back__wrapper"
        }
        style={{ width: `${width}px`, height: `${height}px` }}
      >
        <div className="card-back__inner">
          <div
            className={
              status === "questionnaire" || status === "sent"
                ? "card-back__content card-back__content--questionnaire"
                : "card-back__content card-back__content--default"
            }
          >
            {status === "questionnaire" && <QuestionnaireTextSVG scale={scaleFactor} />}
            {status === "sent" && <WavePatternSVG scale={scaleFactor} />}
          </div>
        </div>
      </div>
    );
  }
);
